import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import backgroundImage from "../../../assets/images/game/down1.jpg";

export default function Pic() {
    const [searchParams] = useSearchParams();
    const imgPath = searchParams.get("imgPath"); // 动态图片 URL
    const [finalImageUrl, setFinalImageUrl] = useState(""); // 最终合并后的图片 URL

    // 静态背景图路径（改用 import + 直接引用）

    // 图片转 Image 对象（处理跨域问题）
    const loadImage = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // 处理跨域
            img.onload = () => resolve(img);
            img.onerror = (err) => reject(new Error("图片加载失败"));
            img.src = url;
        });
    };

    // 计算 cover 模式的绘制参数（背景图填充整个 Canvas）
    const calculateCoverParams = (img, canvasWidth, canvasHeight) => {
        const imgRatio = img.width / img.height;
        const canvasRatio = canvasWidth / canvasHeight;

        let drawWidth, drawHeight, offsetX = 0, offsetY = 0;

        if (imgRatio > canvasRatio) {
            // 图片比 Canvas 更宽，按高度缩放
            drawHeight = canvasHeight;
            drawWidth = img.width * (drawHeight / img.height);
            offsetX = (drawWidth - canvasWidth) / -2; // 水平居中（裁剪两侧）
        } else {
            // 图片比 Canvas 更高，按宽度缩放
            drawWidth = canvasWidth;
            drawHeight = img.height * (drawWidth / img.width);
            offsetY = (drawHeight - canvasHeight) / -2; // 垂直居中（裁剪上下）
        }

        return { drawWidth, drawHeight, offsetX, offsetY };
    };

    // 计算 contain 模式的绘制参数（动态图片完整显示）
    const calculateContainParams = (img, canvasWidth, canvasHeight) => {
        const maxHeight = canvasHeight * 0.8; // 动态图片最大高度为屏幕高度的 80%

        // 默认按原始 contain 模式计算
        let drawWidth, drawHeight, offsetX = 0, offsetY = 0;

        // 1. 尝试按高度缩放（不超过 maxHeight）
        drawHeight = Math.min(img.height * (canvasWidth / img.width), maxHeight);
        drawWidth = img.width * (drawHeight / img.height);

        // 2. 如果按宽度缩放后高度仍然超过 maxHeight，则改按高度缩放
        if (drawHeight > maxHeight) {
            drawHeight = maxHeight;
            drawWidth = img.width * (drawHeight / img.height) - 20;
        }

        // 3. 计算居中偏移
        offsetX = (canvasWidth - drawWidth) / 2 + 15; // 水平居中
        offsetY = (canvasHeight - drawHeight) / 2; // 垂直居中

        return { drawWidth, drawHeight, offsetX, offsetY };
    };

    // 合并两张图片到同一个 Canvas
    const mergeImages = async (bgImg, dynamicImg) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 设置 Canvas 尺寸为屏幕尺寸
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // 1. 绘制背景图（cover 模式）
        const bgParams = calculateCoverParams(bgImg, canvas.width, canvas.height);
        ctx.drawImage(
            bgImg,
            bgParams.offsetX, bgParams.offsetY, bgParams.drawWidth, bgParams.drawHeight
        );

        // 2. 绘制动态图片（contain 模式）
        if (dynamicImg) {
            const dynamicParams = calculateContainParams(dynamicImg, canvas.width, canvas.height);
            ctx.drawImage(
                dynamicImg,
                dynamicParams.offsetX, dynamicParams.offsetY,
                dynamicParams.drawWidth, dynamicParams.drawHeight
            );
        }

        return canvas;
    };

    useEffect(() => {
        const loadAndMergeImages = async () => {
            try {
                // 1. 加载背景图
                const bgImg = await loadImage(backgroundImage);

                // 2. 加载动态图片（如果存在）
                let dynamicImg = null;
                if (imgPath) {
                    try {
                        dynamicImg = await loadImage(imgPath);
                    } catch (dynamicError) {
                        console.error("动态图片加载失败，仅使用背景图:", dynamicError);
                    }
                }

                // 3. 合并图片
                const mergedCanvas = await mergeImages(bgImg, dynamicImg);
                setFinalImageUrl(mergedCanvas.toDataURL("image/png"));
            } catch (error) {
                console.error("图片处理失败:", error);
            }
        };

        loadAndMergeImages();
    }, [imgPath]); // 依赖 imgPath 变化

    return (
        <div className="download-page">
            {finalImageUrl ? (
                <img
                    src={finalImageUrl}
                    alt="生成的图片"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
            ) : (
                <p>图片加载中...</p>
            )}
            <p className="tip">长按或截图保存</p>
        </div>
    );
}